import React, { useContext, useEffect, useState } from "react";
import style from "../style/TempAccount.module.scss";
import { useNavigate } from "react-router-dom";
import { TextField, MenuItem, Autocomplete } from "@mui/material";
import { Button } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { AuthContext } from "../contexts/AuthContext";
import { useMutation, useQuery, useQueryClient } from "react-query";
import CountDown from "../components/CountDown";
import apiClient from "../libraries/ApiClient";
import LoadingModal from "../components/Modal/LoadingModal";
import { v4 as uuidv4 } from "uuid";

const CssTextField = styled((props) => <TextField {...props} fullWidth />)(
  ({ theme }) => ({
    "& .MuiFilledInput-root": {
      border: "1px solid #e2e2e1",
      overflow: "hidden",
      borderRadius: 4,
      backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
      transition: theme.transitions.create([
        "border-color",
        "background-color",
        "box-shadow",
      ]),
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&:hover:not(.Mui-disabled):before": {
        borderBottom: "none",
      },
      "&:before": {
        border: "none",
      },
      "&:after": {
        border: "none",
      },
      "&.Mui-focused": {
        backgroundColor: "transparent",
        boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-error": {
        borderColor: "#EB4D3D",
      },
    },
  })
);
const CssButton = styled(Button)({
  fontSize: 16,
  background: "#057AFF",
  "&:disabled": {
    border: "1px solid #818181",
    color: "#818181",
    background: "#E0E0E0",
  },
  "&:hover": {
    cursor: "pointer",
  },
});

function TempAccount() {
  const codeRule = /^-?\d*\.?\d*$/;
  const navigate = useNavigate();
  const queryClint = useQueryClient();

  // const { mailValue } = useContext(LoginContext);
  const { myAuth, setMyAuth } = useContext(AuthContext);
  const { Account, AccountRowId } = myAuth;
  // console.log(Account,AccountRowId);
  // console.log(Account);

  const [code, setCode] = useState("");
  const [PhoneVaild, setPhoneVaild] = useState(false);
  const [NameVaild, setNameVaild] = useState(false);
  const [MailVaild, setMailVaild] = useState(false);
  const [AccountVaild, setAccountVaild] = useState(false);
  const [timeLeft, setTimeLeft] = useState(180); // 180 seconds = 3 minutes
  const [isRunning, setIsRunning] = useState(true);

  //所屬醫院
  const [OrgCode, setOrgCode] = useState("");
  const [OrgName, setOrgName] = useState("");
  //管理者姓名
  const [Name, setName] = useState("");
  //帳號手機
  const [Phone, setPhone] = useState("");
  const [Mail, setMail] = useState("");
  const [hasPhoneError, setHasPhoneError] = useState(false);
  const [NameError, setNameError] = useState(false);
  const [MailError, setMailError] = useState(false);
  const [OrgError, setOrgError] = useState(false);

  const [token, setToken] = useState("");
  const [AccountId, setAccountId] = useState("");
  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
    setAccountId(JSON.parse(localStorage.getItem("auth"))?.AccountRowId);
  }, []);

  //查詢醫院資料
  const getHospitalData = async ({ queryKey }) => {
    const data = {
      Data: {
        DisableLS: true,
      },
    };

    const res = await apiClient.postAes("api/referral/GetOrg/Security", data);

    return res?.data?.Data?.Orgs;
  };

  const { data: hospitalData, isLoading } = useQuery(
    ["getHospitalData", token],
    getHospitalData,
    {
      // enabled: !!token,
      refetchOnWindowFocus: false,
    }
  );

  const handleHospitalChange = (e) => {
    const input = e.target.innerText;
    // setOrgName(e);
    // console.log(hospitalData.find((h) => h.Name == e).Code, "OrgCode");
    console.log(e.target.innerText);
    // console.log(hospitalData);
    if (e === "") {
    } else {
      let result = hospitalData.find((h) => h.Name === input);
      setOrgCode(result.Code);
    }
  };

  const handleHospitalBlur = (e) => {
    const input = e.target.value;
    // console.log(input);
    if (input === "") {
      setOrgError(true);
    } else {
      //確認是否在清單內
      setOrgError(false);
    }
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleNameBlur = (e) => {
    const input = e.target.value;
    if (input === "") {
      setNameError(true);
      setNameVaild(false);
    } else {
      setNameError(false);
      setNameVaild(true);
    }
  };

  const handleMailChange = (e) => {
    setMail(e.target.value);
  };

  const handleMailBlur = (e) => {
    const emailRule = /^\S.{5,}$/;
    const input = e.target.value;
    if (input === "") {
      // setMailError(true);
      setMailVaild(false);
    } else {
      const result = emailRule.test(e.target.value);
      setMailError(!result);
      setMailVaild(result);
    }
  };

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
  };
  const handlePhoneBlur = (e) => {
    const phoneNumberRule = /^09\d{8}$|^$/;
    if (e.target.value === "") {
      // setHasPhoneError(true);
      setPhoneVaild(false);
    } else {
      const result = phoneNumberRule.test(e.target.value);
      setHasPhoneError(!result);
      setPhoneVaild(result);
    }
    console.log(PhoneVaild);
    console.log(NameVaild);
  };

  const checkAccountVaild = () => {
    if (Mail != "" && Phone != "") {
      return PhoneVaild && MailVaild;
    }
    console.log(PhoneVaild);
    console.log(MailVaild);
    return PhoneVaild || MailVaild;
  };

  const sendTempData = async ({ OrgCode, Name, Phone, Mail }) => {
    const data = {
      Data: {
        OrgCode: OrgCode,
        Name: Name,
        Phone: Phone,
        Email: Mail,
      },
    };
    console.log(data);
    const res = await apiClient.postAes(
      "api/account/RegisterTempAccount/Security",
      data
    );

    return res?.data;
  };

  const { data: codeResData, mutate } = useMutation(sendTempData);
  // console.log(codeResData);

  useEffect(() => {
    if (+codeResData?.Code === 0) {
      console.log(codeResData);
      if (codeResData?.Data === null) {
        alert(codeResData?.Message);
      } else {
        const LocalstorageData = {
          authorized: true,
          AccountRowId: codeResData?.Data?.AccountRowId,
          Name: codeResData?.Data?.Name,
          Account: codeResData?.Data?.Account,
          Token: codeResData?.Data?.Token,
          Menu: codeResData?.Data?.Menus,
          SelfIdentities:
            codeResData?.Data?.Identities?.landseed_zonedefense_tbc,
          OtherIdentities: codeResData?.Data?.Identities?.other_zonedefense_tbc,
          Hospital: codeResData?.Data?.OrganizationName,
          HospitalCode: codeResData?.Data?.OrganizationCode,
          IsAdmin: codeResData?.Data?.IsAdmin,
          IsTempAccount: codeResData?.Data?.IsTempAccount,
          // IsOtherHospital: IsOtherHospitalAccount,
        };
        console.log(LocalstorageData);
        localStorage.setItem("auth", JSON.stringify(LocalstorageData));
        const actionUuid = uuidv4();
        localStorage.setItem("actionUuid", actionUuid);
        setMyAuth({ ...LocalstorageData, authorized: true });
        // alert("成功登入");
        navigate("/TempLogin");
      }
    } else if (+codeResData?.Code) {
      alert(codeResData?.Message);
    }
  }, [codeResData]);

  return (
    <div className={style.TempAccount_body}>
      <div className={style.TempAccount_background}></div>
      <svg
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1921 273"
        className={style.triangle}
      >
        <polygon fill="#fff" points="0,273 1921,273 1921,0 "></polygon>
      </svg>
      <div className={style.TempAccount_form_body}>
        <div className={style.logo}>
          <img src="./end_logo.svg" alt="" style={{ width: "20%" }} />
        </div>
        <div className={style.TempAccount_form}>
          <div className={style.TempAccount_form_top}>
            <div className={style.TempAccount_title}>註冊臨時帳號</div>
            <div className={style.TempAccount_little_title}>
              臨時帳號將於註冊成功後12小時失效，請於該名病患轉送後聯絡貴機構
              區域聯防轉診窗口，協助您建置個人帳號，以利未來轉診業務執行。
            </div>
          </div>
          <div className={style.input_content}>
            <div className={style.hospital_box}>
              {hospitalData ? (
                <Autocomplete
                  disablePortal
                  options={hospitalData}
                  sx={{ width: "100%" }}
                  onChange={handleHospitalChange}
                  onBlur={handleHospitalBlur}
                  error={OrgError}
                  disableClearable
                  getOptionLabel={(option) => option && option.Name}
                  renderInput={(params) => (
                    <CssTextField
                      {...params}
                      variant="filled"
                      label="請選擇所屬醫院"
                    />
                  )}
                />
              ) : (
                <Autocomplete
                  disablePortal
                  options={[]}
                  sx={{ width: "100%" }}
                  onChange={handleHospitalChange}
                  onBlur={handleHospitalBlur}
                  error={OrgError}
                  disableClearable
                  renderInput={(params) => (
                    <CssTextField
                      {...params}
                      variant="filled"
                      label="請選擇所屬醫院"
                    />
                  )}
                />
              )}
            </div>
            <div className={style.input_name}>
              <CssTextField
                label="請輸入您的姓名"
                variant="filled"
                error={NameError}
                onBlur={handleNameBlur}
                onChange={handleNameChange}
                value={Name}
                // error={hasMailError ? true : false}
                style={{ width: "100%" }}
              />
            </div>
            <div className={style.input_mail}>
              <CssTextField
                label="帳號信箱"
                variant="filled"
                error={MailError}
                onBlur={handleMailBlur}
                onChange={handleMailChange}
                value={Mail}
                // error={hasMailError ? true : false}
                style={{ width: "100%" }}
              />
            </div>
            <div className={style.input_phone}>
              <CssTextField
                label="帳號手機"
                variant="filled"
                value={Phone}
                error={hasPhoneError}
                onBlur={handlePhoneBlur}
                onChange={handlePhoneChange}
                style={{ width: "100%" }}
              />
              <div
                style={{ color: "#EB4D3D", fontSize: "13px", padding: "4px" }}
              >
                {hasPhoneError && "手機號碼格式錯誤"}
              </div>
            </div>
            <div className={style.btn}>
              <CssButton
                variant="contained"
                onClick={() => {
                  mutate({ OrgCode, Name, Phone, Mail });
                }}
                disabled={!checkAccountVaild() || !NameVaild || OrgError}
              >
                註冊
              </CssButton>
              <LoadingModal isOpen={isLoading} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TempAccount;
